<template>
    <hts-modal
        v-model="visible"
        title="Huỷ đơn hàng"
        @close="resetFields">
        <template #custom>
            <p class="font-bold">
                Khi bạn thực hiện thao tác hủy đơn hàng, chuyến hàng và chặng hàng của đơn hàng cũng sẽ bị hủy và không thể khôi phục
            </p>

            <hts-form-radio
                v-model="reason"
                label="Vui lòng chọn lí do hủy"
                :items="reasonOptions"
                value-key="key"
                label-key="label"
                required />

            <hts-form-input
                v-if="reason === 'other'"
                v-model="reasonOrther"
                required
                label="Lý do khác" />

            <div class="flex mt-5 justify-end">
                <hts-form-button
                    color="primary"
                    type="submit"
                    :loading="false"
                    :disabled="CDisabled"
                    @click="submit">
                    Huỷ đơn
                </hts-form-button>

                <hts-form-button
                    class="pl-2"
                    color="error"
                    @click="close">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
            </div>
        </template>
    </hts-modal>
</template>

<script setup lang="ts">
import reasonOption from '../../journey/-components/journey/reason'
import { $api, $url } from '#imports'
const emits = defineEmits(['refreshTables'])

const visible = ref(false)

const journeyId = ref('')

const { reason, reasonOrther, reasonOptions, CReasonLabel, CDisabled } = reasonOption()

const open = (id: string) => {
  journeyId.value = id
  visible.value = true
}

const close = () => {
  resetFields()
  visible.value = false
}

const resetFields = () => {
  journeyId.value = ''
  reason.value = ''
  reasonOrther.value = ''
}

const submit = async () => {
  const api = $url.order.order.cancel

  const data: any = await $api(api, {
    uriParams: { ID: journeyId.value },
    body: {
      reasonCancel: reason.value,
      reasonCancelLabel: CReasonLabel.value
    }
  })

  const resData = data?.data?.value
  if (resData?.success) {
    emits('refreshTables')
    process.client && $toast().success($t('labels.cancelSuccess'))
    close()
  }
}

defineExpose({ open })
</script>
